<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-baoxiaoshenqing-feiyongbaoxiaoshenqing-02"></i>报销信息浏览</div>

    <div class="page-content">
      <el-form style="font: bold" :inline="true" label-width="120px" size="small" :model="formInline">
        <el-form-item label="公司名称：">
          <el-input v-model="formInline.companyName" clearable placeholder="公司名称"></el-input>
        </el-form-item>
        <el-form-item label="报销内容：">
          <el-input v-model="formInline.expenseContent" clearable placeholder="报销内容"></el-input>
        </el-form-item>
        <el-form-item label="报销日期：">
          <el-date-picker v-model="formInline.expenseDate" format="yyyy-MM" value-format="yyyy-MM" style="width: 90%" type="month"> </el-date-picker>
        </el-form-item>
        <el-form-item label="报销状态：">
          <el-select v-model="formInline.expenseStatus" clearable placeholder="请选择">
            <!-- <el-option label="请选择" value /> -->
            <el-option v-for="types in dataExpenseStatuss" :key="types.id" :value="types.id" v-text="types.name" :label="types.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="有无发票：">
          <el-select v-model="formInline.invoiceStatus" clearable placeholder="请选择">
            <!-- <el-option label="请选择" value /> -->
            <el-option v-for="types in dataInvoiceStatus" :key="types.id" :value="types.id" v-text="types.name" :label="types.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称：">
          <el-select v-model="formInline.shopName" clearable filterable placeholder="请选择">
            <!-- <el-option label="请选择" value /> -->
            <el-option v-for="types in dataShops" :key="types.shopName" :value="types.shopName" v-text="types.shopName" :label="types.shopName" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="queryParams" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
          <el-button type="primary" @click="addInfo" style="backgroundcolor: #2a3861; bordercolor: transparent">新增 </el-button>
          <el-button type="primary" @click="importSkuInfo()" style="backgroundcolor: #2a3861; bordercolor: transparent">导入 </el-button>
          <el-button type="primary" @click="exportExpense()" style="backgroundcolor: #2a3861; bordercolor: transparent">导出 </el-button>
          <el-button type="primary" @click="batchInfo()" style="backgroundcolor: #2a3861; bordercolor: transparent">批量报销 </el-button>
          <el-button type="primary" @click="templateDownload()" style="backgroundcolor: #2a3861; bordercolor: transparent">下载模板 </el-button>
          <!-- <el-button
                type="primary"
                @click="exportSkuInfo()"
                style="backgroundcolor: #2a3861; bordercolor: transparent"
                >导出
              </el-button> -->
        </el-form-item>
      </el-form>
      <!-- 表格区域  :loading="loading"-->
      <el-table
        height="calc(100vh - 1.8rem)"
        :data="tableData"
        border
        :header-cell-style="{
          'text-align': 'center',
          background: '#F5F6FA',
          color: '#646E92',
        }"
        style="
            width: 96%;
            margin-top: 10px;
            margin-left: 25px;
            color: #666e92;
            font-size: 14px;
          "
        :cell-style="{ 'text-align': 'center' }"
        @cell-dblclick="editData"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40" :selectable="selectable"> </el-table-column>
        <el-table-column label="No" fixed show-overflow-tooltip>
          <template slot-scope="scope"> {{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="expenseDate" label="报销日期" width="120" :formatter="formatTime" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="companyName" label="公司名称" width="180" show-overflow-tooltip> </el-table-column>

        <el-table-column prop="shopName" label="店铺名称" width="180" show-overflow-tooltip> </el-table-column>

        <el-table-column prop="expenseContent" label="报销内容" width="250" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="expensePrice" label="报销金额" width="100" show-overflow-tooltip> </el-table-column>

        <el-table-column prop="invoiceStatus" label="有无发票" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.invoiceStatus == 0 ? "无" : "有" }}
          </template>
        </el-table-column>
        <el-table-column prop="invoiceFile" label="报销发票文件地址" show-overflow-tooltip width="200"> </el-table-column>
        <el-table-column prop="actualExpenseDate" label="实际报销日期" width="120" :formatter="formatTime" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="expenseStatus" label="报销状态" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
              {{ scope.row.expenseStatus == 1 ? "已报销" : scope.row.expenseStatus == 0 ? "未报销" : "外部" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="belongMonthly" label="所属月份" width="120" show-overflow-tooltip :formatter="formatTimeMonth"> </el-table-column>

        <el-table-column align="center" width="120">
          <template slot="header" slot-scope="scope">
            <span>操作</span>
          </template>
          <template slot-scope="scope">
            <el-link :underline="false" style="color: #7698fc" @click="editInfo(scope.row)"><i class="iconfont icon-xiugai" title="编辑"></i></el-link>
            <el-link :underline="false" type="danger" style="margin-right: 10px; cursor: pointer" @click="updateExpense(scope.row)"
              ><i class="iconfont icon-shanchu1" title="删除"></i
            ></el-link>
          </template>
        </el-table-column>
      </el-table>
      <!--尾部-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 15, 20, 25, 30]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        background
      />
      <!-- 新增sku弹框 -->
      <el-dialog :title="modelTitle" width="600px" :visible.sync="addRoleDialog" class="showAll_dialog" :close-on-click-modal="false" :show-close="false" left>
        <el-form label-width="130px" :model="addrole" ref="addrole" :rules="rules1">
          <el-form-item label="公司名称：" prop="companyName">
            <el-input v-model="addrole.companyName"></el-input>
          </el-form-item>

          <el-form-item label="报销内容：" prop="expenseContent">
            <el-input v-model="addrole.expenseContent"></el-input>
          </el-form-item>
          <el-form-item label="报销日期：" prop="expenseDate">
            <el-date-picker v-model="addrole.expenseDate" format="yyyy-MM" value-format="yyyy-MM" style="width: 100%" type="month"> </el-date-picker>
            <!-- <el-input v-model="addrole.expenseDate"></el-input> -->
          </el-form-item>
          <el-form-item label="报销金额：" prop="expensePrice">
            <el-input type="number" v-model="addrole.expensePrice"></el-input>
          </el-form-item>

          <el-form-item label="报销状态：" prop="expenseStatus">
            <el-select v-model="addrole.expenseStatus" clearable placeholder="请选择" style="width: 100%">
              <el-option v-for="types in dataExpenseStatuss" :key="types.id" :value="types.id" v-text="types.name" :label="types.name" />
            </el-select>
          </el-form-item>
          <el-form-item label="有无发票：" prop="invoiceStatus">
            <el-select v-model="addrole.invoiceStatus" clearable placeholder="请选择" style="width: 100%">
              <el-option v-for="types in dataInvoiceStatus" :key="types.id" :value="types.id" v-text="types.name" :label="types.name" />
            </el-select>
          </el-form-item>
          <el-form-item label="店铺名称：" prop="shopName">
            <el-select v-model="addrole.shopName" clearable filterable placeholder="请选择" style="width: 100%">
              <el-option v-for="types in dataShops" :key="types.shopName" :value="types.shopName" v-text="types.shopName" :label="types.shopName" />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="失败原因：" prop="failReason">
            <el-input v-model="addrole.failReason"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button @click="cancelSku()">取 消</el-button>
            <el-button @click="addRole('addrole')" style="background-color: #4c74e0; color: white">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 导入sku文件 -->
      <el-dialog title="报销单上传" width="35%" :visible.sync="importSkuInfoShow" class="import-dialog" :close-on-click-modal="false" left>
        <el-form ref="importFile" :model="upload" :rules="importFilerules" label-width="125px">
          <!-- <el-form-item label="导入月份:" prop="belongMonthly">
            <el-date-picker
              style="width: 70%"
              v-model="upload.belongMonthly"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="month"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="报销单上传：">
            <el-upload
              class="upload-demo"
              ref="upload"
              drag
              :multiple="false"
              action="javascript:void(0)"
              :file-list="fileList"
              :auto-upload="false"
              :on-change="submitUpload"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button @click="importCancel()">取 消</el-button>
            <el-button @click="importCommit()" style="background-color: #4c74e0; color: white">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
import SparkMD5 from "spark-md5";
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {},
  data() {
    var user = window.sessionStorage["user"];
    return {
      importSkuInfoShow: false,
      file: {},
      props: {
        /*配置树形权限菜单显示*/
        label: "name",
        children: "children",
      },
      dataExpenseStatuss: [
        {
          name: "未报销",
          id: 0,
        },
        {
          name: "已报销",
          id: 1,
        },
      ],
      dataInvoiceStatus: [
        {
          name: "无",
          id: 0,
        },
        {
          name: "有",
          id: 1,
        },
      ],
      dataShops: [],
      /*创建角色*/
      addRoleDialog: false,
      addrole: {
        id: undefined,
        companyName: "",
        expenseContent: "",
        expenseDate: "",
        expensePrice: "",
        expenseStatus: "",
        failReason: "",
        invoiceStatus: "",
        shopName: "",
      },
      modelTitle: "",
      /*编辑角色*/
      editRoleDialog: false,
      editrole: {
        id: undefined,
        name: "",
        description: "",
        authorityIds: [],
      },
      rules1: {
        sku: [{ required: true, message: "sku是必填的", trigger: "blur" }],
        numberPackages: [{ required: true, message: "装箱数是必填的", trigger: "blur" }],
        attribute: [{ required: true, message: "属性是必填的", trigger: "blur" }],
        fnsku: [{ required: true, message: "fnsku是必填的", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },

      importFilerules: { belongMonthly: [{ required: true, message: "请选择月份", trigger: "change" }] },
      data: [{}] /*绑定新增角色树的数据*/,
      formInline: {
        companyName: "",
        expenseContent: "",
        expenseDate: "", //new Date(),
        expenseStatus: "",
        invoiceStatus: "",
        shopName: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      btn: false,
      fileList: [],
      file: {},
      row: "",
      col: "",
      tmpRow: {},
      uploadDialog: false,
      upload: {
        name: "",
        belongMonthly: new Date(),
        chunks: 1,
        ext: "",
      },
      dialogVisible: false,
      fileFnList: [],
      businessType: 0,
      formFilename: "上传文件",
      downDialog: false,
      downDetailfnskuPdfPath: "",
      skuId: "",
      dataSites: [],
      flagClick: false,
      // 双击修改
      attribute: false,
      cost: false,
      failReason: false,
      fnsku: false,
      numberPackages: false,
      packagesHigh: false,
      packagesLong: false,
      packagesWeight: false,
      packagesWide: false,
      shopName: false,
      site: false,
      sku: false,
      type: false,
      multipleSelection: [],
    };
  },
  created() {
    this.query(); /*绑定树*/
    this.getAllDicts();
  },
  methods: {
    getAllDicts() {
      /*获取所有字典*/
      this.axios.get("/api/shop/list").then((r) => {
        if (r.data.code == 200) {
          let data = r.data.data;
          this.dataShops = data;
        }
      });
    },
    selectable(row, index) {
      if (row.expenseStatus == 1) {
        return false;
      } else {
        return true;
      }
    },
    // 双击编辑修改sku单元格数据
    editData(row, column) {
      if (column.label.indexOf("SKU") == 0) {
        this.sku = true;
      } else if (column.label.indexOf("属性") == 0) {
        this.attribute = true;
      } else if (column.label.indexOf("装箱数") == 0) {
        this.numberPackages = true;
      } else if (column.label.indexOf("FNSKU") == 0) {
        this.fnsku = true;
      } else if (column.label.indexOf("店铺") == 0) {
        this.shopName = true;
      } else if (column.label.indexOf("站点") == 0) {
        this.site = true;
      } else if (column.label.indexOf("成本") == 0) {
        this.cost = true;
      } else if (column.label.indexOf("装箱(长) CM") == 0) {
        this.packagesLong = true;
      } else if (column.label.indexOf("装箱(宽) CM") == 0) {
        this.packagesWide = true;
      } else if (column.label.indexOf("装箱(高) CM") == 0) {
        this.packagesHigh = true;
      } else if (column.label.indexOf("装箱重量 KG") == 0) {
        this.packagesWeight = true;
      } else if (column.label.indexOf("类别") == 0) {
        this.type = true;
      }
      this.row = row.id;
      this.col = column.id;
      this.tmpRow = row;
      this.tmpRow.id = row.id;
      this.tmpRow.label = column.label;
    },

    //修改信息后调用修改信息的Api
    //双击失焦后的事件
    updateskuInfo() {
      let order = "";
      if (this.sku && this.tmpRow.label == "SKU") {
        order = { id: this.tmpRow.id, sku: this.tmpRow.sku };
      } else if (this.attribute && this.tmpRow.label == "属性") {
        order = { id: this.tmpRow.id, attribute: this.tmpRow.attribute };
      } else if (this.numberPackages && this.tmpRow.label == "装箱数") {
        order = { id: this.tmpRow.id, numberPackages: this.tmpRow.numberPackages };
      } else if (this.fnsku && this.tmpRow.label == "FNSKU") {
        order = { id: this.tmpRow.id, fnsku: this.tmpRow.fnsku };
      } else if (this.shopName && this.tmpRow.label == "店铺") {
        order = { id: this.tmpRow.id, shopName: this.tmpRow.shopName };
      } else if (this.cost && this.tmpRow.label == "成本") {
        order = { id: this.tmpRow.id, cost: this.tmpRow.cost };
      } else if (this.packagesLong && this.tmpRow.label == "装箱(长) CM") {
        order = { id: this.tmpRow.id, packagesLong: this.tmpRow.packagesLong };
      } else if (this.packagesWide && this.tmpRow.label == "装箱(宽) CM") {
        order = { id: this.tmpRow.id, packagesWide: this.tmpRow.packagesWide };
      } else if (this.packagesHigh && this.tmpRow.label == "装箱(高) CM") {
        order = { id: this.tmpRow.id, packagesHigh: this.tmpRow.packagesHigh };
      } else if (this.packagesWeight && this.tmpRow.label == "装箱重量 KG") {
        order = { id: this.tmpRow.id, packagesWeight: this.tmpRow.packagesWeight };
      } else if (this.type && this.tmpRow.label == "类别") {
        order = { id: this.tmpRow.id, type: this.tmpRow.type };
      } else if (this.site && this.tmpRow.label == "站点") {
        order = { id: this.tmpRow.id, site: this.tmpRow.site };
      }
      console.log(order, "role");
      if (order != null && order != "") {
        this.axios.put("/api/sku-info/modify", order).then(
          (resp) => {
            if (resp.data.code == 200) {
              this.$message("修改成功");
              this.query(); /*查询渲染界面*/
            } else {
              this.$message.info(resp.data.msg);
            }
            //清空数据
            this.tmpRow = {};
            this.row = "";
            this.col = "";
          },
          (err) => {
            console.log("err", err);
          }
        );
      }
    },

    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined || date == null) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    formatTimeMonth(row, column) {
      let date = row[column.property];
      if (date === undefined || date == null) {
        return "";
      }
      return moment(date).format("YYYY-MM");
    },
    handleSizeChange(val) {
      /*改变显示条数*/
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },
    putdata(resp) {
      console.log(resp.data, "resp.data");
      this.$data.tableData = resp.data.data && resp.data.data.records ? resp.data.data.records : [];
      this.$data.total = resp.data.data.total;
    },
    queryParams() {
      this.$data.currentPage = 1;
      this.query();
    },
    query() {
      //条件筛选
      let o = {
        ...this.formInline,
      };
      if (o.expenseDate != "" && o.expenseDate != null && o.expenseDate != undefined) {
        o.expenseDate = moment(o.expenseDate).format("yyyy-MM");
      } else {
        delete o.expenseDate;
      }

      this.axios
        .get("/api/expense-account/page", {
          // , sku: this.$data.formInline.sku, type: this.$data.formInline.type
          params: { ...o, current: this.$data.currentPage, size: this.$data.pageSize },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    },
    handleSelectionChange(val) {
      let selectId = [];
      if (val) {
        val.forEach(function(item, index) {
          if (item) {
            selectId.push(item.id);
          }
        });
      }
      this.multipleSelection = selectId;
      console.log(selectId + "---selectId");
    },
    addSkuinfo() {
      this.addRoleDialog = true;
      this.modelTitle = "新增SKU信息";
      this.flagClick = true;
    },
    cancelSku() {
      // if (this.flagClick) {
      //   this.$refs.addrole.resetFields();
      // } else {
      this.addrole = {
        id: undefined,
        sku: "",
        attribute: "",
        numberPackages: "",
        fnsku: "",
        type: 11002001,
        site: "",
        shopName: "",
        packagesHigh: "",
        cost: "",
        packagesLong: "",
        packagesWeight: "",
        packagesWide: "",
      };
      // }
      this.addRoleDialog = false;
    },
    addInfo() {
      this.addRoleDialog = true;
      this.modelTitle = "新增报销单信息";
    },
    editInfo(row) {
      /*绑定修改信息*/
      console.log(row, "row");
      this.addRoleDialog = true;
      this.modelTitle = "修改报销单信息";
      this.addrole = JSON.parse(JSON.stringify(row));
      this.addrole.expenseDate = moment(row.expenseDate).format("yyyy-MM-DD");
    },
    addRole(addrole) {
      /*新增修改*/
      this.$refs[addrole].validate((valid) => {
        if (valid) {
          let role = { ...this.addrole };
          role.expenseDate = moment(role.expenseDate).format("yyyy-MM-DD");
          delete role.actualExpenseDate, role.createTime, role.belongMonthly, role.updateTime;
          console.log(role, "ssss");
          if (role.id) {
            this.axios.put("/api/expense-account/modify", role).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message("修改成功");
                  this.query(); /*查询渲染界面*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log("err", err);
              }
            );
          } else {
            this.axios.post("/api/expense-account/add", role).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message("添加成功");
                  this.query(); /*查询渲染界面*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log("err", err);
              }
            );
          }
          this.cancelSku(); /*关闭弹窗*/
        } else {
          console.log("验证没通过");
          return false;
        }
      });
    },
    // 导入
    importSkuInfo() {
      this.importSkuInfoShow = true;
    },
    downloadCallback(res, fileName) {
      var blob = new Blob([res.data], 
        {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'});
        var download = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        download.style.display = 'none';
        download.href = href;
        download.download =fileName ; //下载后文件名
        document.body.appendChild(download);
        download.click(); //点击下载
        document.body.removeChild(download); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    getFileName(res) {
      let fileName=decodeURI((res.headers['content-disposition'].split('='))[1]);
      return fileName;
    },
    templateDownload() {
      this.$msgbox
        .confirm("此操作将下载模板, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let path = "/api/sku-info/templateDownload?path=/order/template/报销单导入示例.xlsx";
          this.axios({
            url: path,
            method: 'get',
            responseType: 'blob',
          }).then(res => {
              console.log('res', res);
              this.downloadCallback(res, this.getFileName(res));
            }
          ).catch(err => {
            console.log(err.message);
          });
          /*加个下载成功的进度条*/
          setTimeout(() => {
            this.$message({
              message: "下载成功",
              type: "success",
              center: true,
            });
          }, 500);
        })
        .catch(() => {
          this.$message.error("已取消下载");
        });
    },

    // 新增报销单
    addExpense() {


    },
    updateExpense(row) {
      this.$msgbox
        .confirm("此操作将删除报销单信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.axios.delete("/api/expense-account/removeById?id=" + row.id).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.$message("删除成功");
                this.query();
              } else {
                this.$message(resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        })
        .catch(() => {
          this.$message.error("已取消");
        });
    },
    importCommit() {
      this.$refs["importFile"].validate((valid) => {
        if (valid) {
          if (!this.upload.name) {
            this.$message.error("请先选择文件！");
            return;
          }
          // let o = {};
          // o.belongMonthly = moment(o.belongMonthly).format('YYYY-MM')
          let formData = new FormData();
          // 向 formData 对象中添加文件
          //formData.append("dto", JSON.stringify(o));
          formData.append("file", this.upload.file.raw);
          let config = {
            //添加请求头
            headers: { "Content-Type": "multipart/form-data" },
            //添加上传进度监听事件
            onUploadProgress: (e) => {
              var completeProgress = (((e.loaded / e.total) * 100) | 0) + "%";
              this.progress = completeProgress;
            },
          };
          this.$http.post("/api/expense-account/importExpenseAccount", formData, config).then(
            (resp) => {
              let baseurl = this.axios.defaults.baseURL;
              this.upload = {};
              if (resp.data.code == 200) {
                // 导入正确
                let path = resp.data.data.failFilePath;
                // failFilePath有的话是导入条目失败了 有失败原因
                if (path) {
                  let pathT = "/api/sku-info/templateDownload?path=" + path;
                  this.axios({
                    url: pathT,
                    method: 'get',
                    responseType: 'blob',
                  }).then(res => {
                      console.log('res', res);
                      this.downloadCallback(res, this.getFileName(res));
                    }
                  ).catch(err => {
                    console.log(err.message);
                  });
                  // window.open(`${baseurl}` + path, "_blank");
                } else {
                  this.$message("上传成功");
                  this.importCancel();
                  this.query();
                }
                // 提示导入信息
                setTimeout(() => {
                  this.$message(resp.data.data.result);
                }, 3000);
              } else {
                let path = resp.data.failFilePath;
                if (path) {
                  path = "/order/template/报销单导入示例.xlsx";
                }
                let pathT = "/api/sku-info/templateDownload?path=" + path;
                this.axios({
                  url: pathT,
                  method: 'get',
                  responseType: 'blob',
                }).then(res => {
                    console.log('res', res);
                    this.downloadCallback(res, this.getFileName(res));
                  }
                ).catch(err => {
                  console.log(err.message);
                });
                // window.open(`${baseurl}/api/sku-info/templateDownload?path=` + path, "_blank");
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        }
      });
    },
    submitUpload(file, fileList) {
      this.file = file;
      let s = file.name;
      this.upload.ext = s.substr(s.lastIndexOf(".") > 0 ? s.lastIndexOf(".") + 1 : 0);
      this.fileList = fileList.slice(-1);
      this.upload.name = file.name;
      this.upload.file = file;
    },
    importCancel() {
      this.fileList = [];
      this.upload = {
        name: "",
        belongMonthly: new Date(),
        chunks: 1,
        ext: "",
      };
      this.importSkuInfoShow = false;
    },
    // 导出报销单
    exportExpense() {
      let path = '/api/expense-account/export-expense?1=1';
      if (this.formInline.companyName) {
        path += "&companyName=" + this.formInline.companyName;
      } 
      if (this.formInline.expenseContent) {
        path += "&expenseContent=" + this.formInline.expenseContent;
      }
      if (this.formInline.expenseDate) {
        path += "&expenseDate=" + this.formInline.expenseDate;
      }
      if (this.formInline.expenseStatus != null) {
        path += "&expenseStatus=" + this.formInline.expenseStatus;
      }
      if (this.formInline.invoiceStatus != null) {
        path += "&invoiceStatus=" + this.formInline.invoiceStatus;
      }
      if (this.formInline.shopName) {
        path += "&shopName=" + this.formInline.shopName;
      }
      this.axios({
        url: path,
        method: 'get',
        responseType: 'blob',
      }).then(res => {
          console.log('res', res);
          this.downloadCallback(res, '报销单列表.xlsx');
        }
      ).catch(err => {
        console.log(err.message);
      });
    },
    batchInfo() {
      if (this.multipleSelection.length > 0) {
        this.$msgbox
          .confirm("确定批量报销所选数据吗？, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            this.axios.put("/api/expense-account/batchExpense", this.multipleSelection).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message("批量报销成功");
                  this.query(); /*查询渲染界面*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log("err", err);
              }
            );
          })
          .catch(() => {
            this.$message.error("已取消");
          });
      } else {
        this.$message.info("请选中至少一行数据!");
      }
    },
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #78b1ca;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 50px);
    overflow: hidden;
    .el-form{
      width: 100%;
      line-height: 36px;
      margin-top: 15px;
    }
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #78b1ca;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}

.ant-card {
  width: 1230px;
  height: 600px;
  background: #ffffff;
  border-radius: 6px;

  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  transition: all 0.3s;
}
.showAll_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ::v-deep .el-dialog {
    margin: 0 auto !important;
    height: 80%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
      // 下边设置字体，我的需求是黑底白字
      color: #ffffff;
      line-height: 30px;
      padding: 0 15px;
    }
  }
}
</style>
